exports = module.exports = require("../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-gallery-image > img {\n  image-resolution: 3000dpi;\n}", ""]);

// exports
